import { action, computed, observable } from 'mobx'

interface ILoaderOptions {
  key?: string
  showText?: boolean
}

const DEFAULT_LOADER_OPTIONS = {
  key: 'commonKey',
  showText: false,
}

export class PageLoaderService {
  @observable
  keys = observable.map()
  @observable
  textIndex = -1
  @observable
  showText = false

  private interval: ReturnType<typeof setInterval> | null = null
  private messages = []

  @computed
  get isLoading() {
    return this.keys.size > 0
  }

  @action
  show(options: ILoaderOptions = DEFAULT_LOADER_OPTIONS) {
    const { key = 'commonKey', showText = false } = options
    this.cleanInterval()
    if (showText) {
      this.textIndex++
      this.interval = setInterval(() => {
        this.textIndex++
      }, 15000)
    }
    this.showText = showText
    this.keys.set(key, true)
  }

  @action
  hide(key?: string) {
    this.cleanInterval()
    if (key) {
      this.keys.delete(key)
    } else {
      this.keys.clear()
    }
  }

  private cleanInterval() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
